/**
 * LLM-9E — promotion flow helpers for conversation-bound memory suggestions.
 */

export const PROMOTION_UI_STATE = {
  IDLE: "IDLE",
  DISMISSED: "DISMISSED",
  PROMOTION_STARTING: "PROMOTION_STARTING",
  WAITING_FOR_CONFIRMATION: "WAITING_FOR_CONFIRMATION",
  CONFIRMING: "CONFIRMING",
  REJECTING: "REJECTING",
  SAVED: "SAVED",
  NOT_SAVED: "NOT_SAVED",
  ERROR_PROMOTION: "ERROR_PROMOTION",
  ERROR_UNKNOWN: "ERROR_UNKNOWN",
};

export const CONFIRM_REPLY = "Yes";
export const REJECT_REPLY = "No";

export const createClientMessageId = () =>
  `llm9e-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

/**
 * @param {{ message: string, expectedRevision: number, clientMessageId?: string }} params
 */
export const buildSessionMessageRequest = ({
  message,
  expectedRevision,
  clientMessageId = createClientMessageId(),
}) => ({
  message,
  client_message_id: clientMessageId,
  expected_conversation_revision: expectedRevision,
  payload: {},
  field_values: {},
  detail_level: "STANDARD",
});
